import { memo } from 'react';

import { InceptIcon, InceptIconProps } from '../InceptIcon';

const IconAssetCaravanComponent: React.FC<InceptIconProps> = ({
  color = 'var(--chakra-colors-brand-primary-fg, currentColor)',
  brandColor = 'var(--chakra-colors-brand-primary-solid)',
  fillColor = 'var(--chakra-colors-brand-primary-contrast)',
  viewBox = '0 0 80 80',
  ...props
}: InceptIconProps) => (
  <InceptIcon viewBox={viewBox} {...props}>
    <g
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      strokeWidth="0.75"
    >
      <g clipPath="url(#a)">
        <path
          d="M60.994 53.786c-1.353-.787-1.353-3.337 0-5.699s3.546-3.637 4.899-2.85l-4.342-2.525c-1.353-.787-3.546.488-4.9 2.85-1.352 2.361-1.352 4.911 0 5.698z"
          fill={fillColor}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="M60.99 54.196a.4.4 0 0 1-.206-.058l-4.342-2.525c-1.57-.914-1.636-3.661-.147-6.257.939-1.64 2.288-2.833 3.603-3.185.69-.185 1.333-.123 1.858.184l4.341 2.526a.41.41 0 0 1 .148.562.41.41 0 0 1-.562.147c-.336-.197-.75-.23-1.23-.102-1.094.29-2.283 1.365-3.107 2.8-1.218 2.124-1.288 4.477-.152 5.141a.413.413 0 0 1-.21.767zm-.341-11.304q-.252 0-.541.078c-1.095.291-2.284 1.366-3.108 2.8-1.218 2.124-1.287 4.478-.148 5.142l2.825 1.644c-.316-1.267 0-2.997.955-4.666.927-1.615 2.247-2.792 3.543-3.165l-2.837-1.648a1.35 1.35 0 0 0-.693-.176z"
          fill={color}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="M60.993 53.786c1.353.787 3.547-.488 4.9-2.85s1.353-4.911 0-5.699c-1.353-.787-3.547.488-4.9 2.85s-1.353 4.912 0 5.699"
          fill={fillColor}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="M61.891 54.43c-.402 0-.779-.099-1.107-.288-1.57-.914-1.636-3.66-.151-6.256.938-1.64 2.287-2.833 3.603-3.186.69-.184 1.333-.123 1.858.185 1.57.914 1.635 3.661.151 6.256-.939 1.64-2.288 2.833-3.604 3.186a2.9 2.9 0 0 1-.75.102m3.104-9.012q-.253 0-.541.078c-1.095.29-2.284 1.365-3.108 2.8-1.218 2.124-1.287 4.477-.152 5.141.336.197.75.23 1.234.103 1.095-.291 2.284-1.365 3.108-2.8 1.218-2.124 1.287-4.477.152-5.142a1.35 1.35 0 0 0-.693-.176z"
          fill={color}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="M37.657 67.356c-1.353-.787-1.353-3.337 0-5.698s3.547-3.637 4.9-2.85l-4.342-2.525c-1.353-.788-3.547.487-4.9 2.849-1.352 2.361-1.352 4.912 0 5.699z"
          fill={fillColor}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="M37.653 67.766a.4.4 0 0 1-.205-.057l-4.342-2.526c-1.57-.914-1.636-3.66-.148-6.256.94-1.64 2.288-2.833 3.604-3.186.689-.184 1.333-.123 1.857.185l4.342 2.525a.41.41 0 0 1 .148.562.41.41 0 0 1-.562.148c-.336-.197-.75-.23-1.23-.103-1.095.291-2.284 1.365-3.108 2.8-1.217 2.124-1.287 4.477-.151 5.142a.412.412 0 0 1-.21.767zm-.34-11.307q-.254-.002-.542.078c-1.095.29-2.283 1.365-3.108 2.8-1.217 2.124-1.287 4.477-.147 5.141l2.825 1.644c-.316-1.267 0-2.997.955-4.665.926-1.616 2.247-2.792 3.542-3.166l-2.837-1.648a1.35 1.35 0 0 0-.693-.176z"
          fill={color}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="M37.657 67.356c1.353.788 3.547-.488 4.9-2.85 1.353-2.36 1.353-4.91 0-5.698-1.353-.787-3.547.488-4.9 2.85s-1.353 4.911 0 5.698"
          fill={fillColor}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="M38.555 68c-.402 0-.78-.098-1.107-.287-1.57-.914-1.636-3.661-.148-6.256.939-1.64 2.288-2.833 3.604-3.186.689-.184 1.332-.123 1.857.184 1.57.915 1.636 3.662.148 6.257-.94 1.64-2.288 2.833-3.604 3.185a2.9 2.9 0 0 1-.75.103m3.1-9.016q-.254 0-.542.078c-1.095.291-2.284 1.366-3.108 2.8-1.217 2.124-1.287 4.477-.147 5.142.336.197.75.23 1.234.102 1.094-.29 2.283-1.365 3.108-2.8 1.217-2.124 1.287-4.477.147-5.141a1.35 1.35 0 0 0-.693-.176z"
          fill={color}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="M12.579 42.483c-.19.086-.64.262-1.222.18a2.24 2.24 0 0 1-1.247-.607v-3.58c.218-.077.673-.208 1.247-.122a2.55 2.55 0 0 1 1.222.55z"
          fill={fillColor}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="M11.656 43.093a2.687 2.687 0 0 1-1.833-.742.4.4 0 0 1-.127-.295v-3.58c0-.171.107-.327.27-.384a2.94 2.94 0 0 1 2.87.491.4.4 0 0 1 .148.316v3.58a.41.41 0 0 1-.242.372 2.7 2.7 0 0 1-1.094.238zm-1.136-1.222a1.81 1.81 0 0 0 1.653.328v-3.09a2.1 2.1 0 0 0-1.649-.325v3.087z"
          fill={color}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="M29.942 66.282 11.82 55.746a1.82 1.82 0 0 1-.918-1.587v-7.88l18.125 10.545V64.7c0 .7.377 1.279.91 1.586z"
          fill={fillColor}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="M29.941 66.692a.4.4 0 0 1-.205-.053h-.004l-18.117-10.54a2.22 2.22 0 0 1-1.12-1.944v-7.88a.411.411 0 0 1 .616-.357l18.125 10.545a.41.41 0 0 1 .205.353v7.875c0 .517.262.976.701 1.23a.413.413 0 0 1-.21.767zM11.316 46.988v7.167c0 .512.266.975.713 1.234l16.62 9.667a2 2 0 0 1-.028-.36v-7.639z"
          fill={color}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="m14.985 34.033-4.08 12.242L29.032 56.82l4.08-12.247z"
          fill={brandColor}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="M29.031 57.23a.4.4 0 0 1-.205-.058l-18.13-10.54a.41.41 0 0 1-.184-.484l4.08-12.242a.41.41 0 0 1 .245-.255.41.41 0 0 1 .353.03l18.126 10.536a.41.41 0 0 1 .184.483l-4.08 12.247a.4.4 0 0 1-.389.279zM11.398 46.09l17.404 10.123 3.813-11.451-17.4-10.118-3.813 11.446z"
          fill={color}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="M69.87 23.197a1.8 1.8 0 0 0-1.82 0L34.024 42.978c-.57.328-.91 1.587-.91 1.587v.008l-18.13-10.54s.348-1.263.918-1.587L49.928 12.66a1.8 1.8 0 0 1 1.82 0z"
          fill={fillColor}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="M33.106 44.98a.4.4 0 0 1-.2-.054l-18.13-10.537a.41.41 0 0 1-.19-.463c.066-.238.427-1.443 1.108-1.833l34.025-19.79a2.2 2.2 0 0 1 2.234 0L70.074 22.84a.41.41 0 0 1 .148.562.41.41 0 0 1-.562.147 1.4 1.4 0 0 0-1.41 0L34.225 43.331c-.29.168-.594.877-.717 1.333a.4.4 0 0 1-.193.258.4.4 0 0 1-.209.057M15.473 33.843l17.403 10.118c.177-.459.484-1.078.94-1.34L67.84 22.84q.16-.092.332-.16l-16.629-9.667a1.4 1.4 0 0 0-1.41 0L16.108 32.799c-.234.135-.48.623-.631 1.045z"
          fill={color}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="M69.87 23.197a1.8 1.8 0 0 0-1.825 0L34.016 42.979c-.565.328-.91 1.59-.91 1.59l-4.08 12.25v7.872c0 .706.382 1.28.911 1.591a1.8 1.8 0 0 0 1.825 0l3.505-2.037c.135-1.054.516-2.186 1.156-3.3 1.324-2.31 3.374-3.797 5.231-3.797.587 0 1.128.143 1.612.422.52.303.934.754 1.226 1.312l14.111-8.204c.136-1.054.517-2.19 1.156-3.304 1.325-2.309 3.375-3.797 5.232-3.797.586 0 1.127.144 1.611.422.52.304.935.755 1.226 1.312l2.042-1.184c.566-.329.91-.935.91-1.591V24.788c0-.706-.381-1.28-.91-1.591"
          fill={fillColor}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="M30.851 66.942c-.385 0-.767-.102-1.12-.307a2.23 2.23 0 0 1-1.114-1.944V56.82c0-.045.008-.086.02-.132l4.08-12.25c.057-.217.418-1.422 1.094-1.816l34.03-19.782a2.2 2.2 0 0 1 2.234 0 2.23 2.23 0 0 1 1.115 1.943v17.749c0 .8-.427 1.545-1.115 1.943l-2.042 1.185a.42.42 0 0 1-.32.04.41.41 0 0 1-.25-.204 2.77 2.77 0 0 0-1.07-1.148 2.75 2.75 0 0 0-1.406-.37c-1.71 0-3.625 1.411-4.875 3.592-.59 1.03-.972 2.12-1.103 3.153a.41.41 0 0 1-.2.304L44.695 59.23a.42.42 0 0 1-.32.041.41.41 0 0 1-.25-.205 2.77 2.77 0 0 0-1.07-1.148 2.75 2.75 0 0 0-1.406-.368c-1.71 0-3.624 1.41-4.875 3.591-.59 1.025-.971 2.116-1.102 3.149a.41.41 0 0 1-.201.303l-3.506 2.038a2.2 2.2 0 0 1-1.119.307zm-1.414-10.057v7.806c0 .517.266.98.709 1.234a1.38 1.38 0 0 0 1.41 0l3.333-1.939c.169-1.078.575-2.197 1.177-3.25 1.394-2.432 3.587-4.002 5.588-4.002.656 0 1.271.16 1.816.48.464.27.857.643 1.165 1.106l13.59-7.9c.169-1.078.575-2.198 1.178-3.251 1.394-2.432 3.587-4.002 5.588-4.002a3.512 3.512 0 0 1 2.985 1.59l1.689-.983c.434-.254.709-.726.709-1.234V24.788c0-.517-.267-.98-.71-1.239a1.39 1.39 0 0 0-1.41 0L34.225 43.331c-.287.168-.598.902-.721 1.345z"
          fill={color}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="m29.03 61.194-4.53-2.632v2.325l4.53 2.632z"
          fill={fillColor}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="M29.031 63.929a.37.37 0 0 1-.205-.058l-4.53-2.636a.41.41 0 0 1-.205-.352v-2.325a.411.411 0 0 1 .615-.357l4.53 2.637a.41.41 0 0 1 .205.352v2.325a.41.41 0 0 1-.41.41zm-4.12-3.28 3.71 2.157v-1.378l-3.71-2.157z"
          fill={color}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="M24.5 60.887v2.23l4.53 2.636V63.52z"
          fill={brandColor}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="M29.031 66.163a.37.37 0 0 1-.205-.057l-4.53-2.636a.41.41 0 0 1-.205-.353v-2.23a.411.411 0 0 1 .615-.357l4.53 2.636a.41.41 0 0 1 .205.353v2.234a.41.41 0 0 1-.205.357.4.4 0 0 1-.205.053m-4.12-3.284 3.71 2.157v-1.283l-3.71-2.157z"
          fill={color}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="M10.905 54.155c0 .709.386 1.279.919 1.586l3.616 2.104v-2.23l-4.53-2.637v1.173z"
          fill={brandColor}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="M15.436 58.255a.37.37 0 0 1-.205-.058l-3.616-2.103a2.22 2.22 0 0 1-1.12-1.943v-1.173a.411.411 0 0 1 .616-.357l4.53 2.637a.41.41 0 0 1 .205.352v2.23a.41.41 0 0 1-.205.357.4.4 0 0 1-.205.053zm-4.12-4.56v.464c0 .512.266.976.713 1.234l3.001 1.742v-1.283l-3.71-2.156z"
          fill={color}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="M10.905 50.658v2.324l4.53 2.632V53.29z"
          fill={fillColor}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="M15.436 56.024a.4.4 0 0 1-.205-.057L10.7 53.33a.41.41 0 0 1-.205-.353v-2.325a.41.41 0 0 1 .615-.356l4.53 2.636a.41.41 0 0 1 .205.353v2.324a.41.41 0 0 1-.205.357.4.4 0 0 1-.205.053zm-4.12-3.28 3.71 2.157v-1.378l-3.71-2.156z"
          fill={color}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="M44.906 39.72v7.367l11.348-6.597v-7.367z"
          fill={brandColor}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="M44.906 47.497a.4.4 0 0 1-.205-.054.41.41 0 0 1-.205-.356v-7.368a.4.4 0 0 1 .205-.352L56.05 32.77a.411.411 0 0 1 .615.357v7.367a.4.4 0 0 1-.206.353l-11.348 6.596a.4.4 0 0 1-.205.058zm.41-7.54v6.42l10.528-6.12v-6.421z"
          fill={color}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="m67.602 26.522-11.348 6.6v7.368l11.348-6.6z"
          fill={brandColor}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="M56.254 40.9a.4.4 0 0 1-.205-.053.41.41 0 0 1-.205-.357v-7.367a.4.4 0 0 1 .205-.353l11.349-6.597a.411.411 0 0 1 .615.357v7.367a.4.4 0 0 1-.205.353l-11.349 6.597a.4.4 0 0 1-.205.057zm.41-7.544v6.42l10.529-6.12v-6.42z"
          fill={color}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="M42.155 41.318v7.368l-10.242 5.953 4.08-9.738z"
          fill={brandColor}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="M31.913 55.049a.409.409 0 0 1-.377-.57l4.08-9.742a.4.4 0 0 1 .172-.196l6.158-3.58a.411.411 0 0 1 .615.357v7.368a.4.4 0 0 1-.206.352l-10.237 5.953a.4.4 0 0 1-.205.057m4.408-9.865-3.555 8.487 8.979-5.22v-6.42z"
          fill={color}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="M34.336 55.13c-.188.087-.64.263-1.221.18a2.24 2.24 0 0 1-1.247-.606v-3.58a2.52 2.52 0 0 1 2.468.427z"
          fill={fillColor}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="M33.41 55.741A2.672 2.672 0 0 1 31.577 55a.4.4 0 0 1-.127-.295v-3.579c0-.172.107-.328.27-.385a2.94 2.94 0 0 1 2.87.492.4.4 0 0 1 .148.315v3.58a.41.41 0 0 1-.242.372 2.7 2.7 0 0 1-1.094.238zm-1.136-1.225c.189.151.488.332.894.385.295.04.553 0 .758-.057v-3.092a2.1 2.1 0 0 0-1.652-.324z"
          fill={color}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="M30.667 57.566a.41.41 0 0 1-.41-.41c0-.759.074-.857.73-1.521.406-.406.447-.783.459-.923.02-.209.119-.34.287-.397a.41.41 0 0 1 .52.254.4.4 0 0 1 .009.234 2.34 2.34 0 0 1-.693 1.41q-.492.495-.492.943c0 .225-.185.41-.41.41"
          fill={color}
          vectorEffect="non-scaling-stroke"
        />
      </g>
      <clipPath id="a">
        <path
          d="M9.7 12h61.494v56H9.7z"
          fill={fillColor}
          vectorEffect="non-scaling-stroke"
        />
      </clipPath>
    </g>
  </InceptIcon>
);

export const IconAssetCaravan = memo(IconAssetCaravanComponent);
